/** How each link type reads from the `from` side (outward) and the `to` side (inward). */
export const LINK_TYPES = {
    relates: { outward: "relates to", inward: "relates to", symmetric: true },
    depends: { outward: "depends on", inward: "is required for", symmetric: false },
    duplicates: { outward: "duplicates", inward: "is duplicated by", symmetric: false },
    subtask: { outward: "subtask of", inward: "parent for", symmetric: false },
};
/** Store key for an attachment target: `i<id>` / `a<id>`. */
export const attachmentKey = (t) => "issueId" in t ? `i${t.issueId}` : "articleId" in t ? `a${t.articleId}` : "draftId" in t ? `d${t.draftId}` : `ad${t.articleDraftId}`;
export function articleKey(projectKey, number) {
    return `${projectKey}-A-${number}`;
}
export function parseArticleKey(key) {
    const m = /^([A-Za-z][A-Za-z0-9_]*)-A-(\d+)$/.exec(key.trim());
    if (!m)
        return null;
    return { projectKey: m[1], number: Number(m[2]) };
}
//# sourceMappingURL=types.js.map